export const COOKIE_NAMES = {
  AI_CHATBOT_ASSISTANT_THREAD_ID: "ai_chatbot_assistant_thread_id",
} as const;
